import React from 'react';

const About: React.FC = () => {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            About Clevor
          </h1>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            We're on a mission to transform how government contractors find, bid, and win contracts.
          </p>
        </div>

        <div className="mt-16 max-w-3xl mx-auto prose prose-lg text-gray-600">
          <p>
            Clevor was founded by a team of former government contractors who experienced firsthand the 
            challenges of finding and winning federal contracts. We built the platform we wished we had 
            — an AI-powered solution that streamlines every step of the GovCon process.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Our Mission</h2>
          <p>
            To democratize access to government contracting by providing small and mid-sized businesses 
            with the same tools and intelligence that large contractors use to win billions in federal awards.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Our Values</h2>
          <ul className="space-y-4">
            <li>
              <strong className="text-gray-900">Innovation:</strong> We constantly push the boundaries of 
              what's possible with AI in government contracting.
            </li>
            <li>
              <strong className="text-gray-900">Security:</strong> Your data security is our top priority. 
              We're committed to maintaining the highest security standards.
            </li>
            <li>
              <strong className="text-gray-900">Customer Success:</strong> Your success is our success. 
              We're dedicated to helping you win more contracts.
            </li>
            <li>
              <strong className="text-gray-900">Integrity:</strong> We believe in transparent pricing, 
              honest communication, and ethical AI practices.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;
